export default __webpack_public_path__ + "static/media/global-icon-three.3a6f3f4f.svg";